import React from 'react';
import { cn } from '../../../lib/utils';
import { Input } from '../../../components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select';
import { Search } from 'lucide-react';
import { UserFiltersProps } from '../types';

export function UserFilters({
  isDark,
  searchQuery,
  roleFilter,
  subscriptionFilter,
  onSearch,
  onRoleFilter,
  onSubscriptionFilter,
}: UserFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 flex-1 lg:flex-initial lg:max-w-xl">
      <div className="relative flex-1">
        <Search className={cn(
          'absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4',
          isDark ? 'text-slate-500' : 'text-slate-400'
        )} />
        <Input
          type="text"
          placeholder="Search users..."
          value={searchQuery}
          onChange={(e) => onSearch(e.target.value)}
          className={cn(
            'pl-10 h-10 rounded-xl border-0',
            isDark 
              ? 'bg-slate-800 text-white placeholder:text-slate-500 focus:ring-[#0EA5A4]' 
              : 'bg-slate-100 text-slate-900 placeholder:text-slate-400 focus:ring-[#0EA5A4]'
          )}
        />
      </div>
      <Select value={roleFilter} onValueChange={onRoleFilter}>
        <SelectTrigger className={cn(
          'w-full sm:w-[140px] h-10 rounded-xl border-0',
          isDark 
            ? 'bg-slate-800 text-white' 
            : 'bg-slate-100 text-slate-900'
        )}>
          <SelectValue placeholder="All roles" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Roles</SelectItem>
          <SelectItem value="user">User</SelectItem>
          <SelectItem value="admin">Admin</SelectItem>
        </SelectContent>
      </Select>
      <Select value={subscriptionFilter} onValueChange={onSubscriptionFilter}>
        <SelectTrigger className={cn(
          'w-full sm:w-[160px] h-10 rounded-xl border-0',
          isDark 
            ? 'bg-slate-800 text-white' 
            : 'bg-slate-100 text-slate-900'
        )}>
          <SelectValue placeholder="All statuses" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Statuses</SelectItem>
          <SelectItem value="true">Subscribed</SelectItem>
          <SelectItem value="false">Free</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
